"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CountryInfo = require("./CountryInfo");
Object.keys(_CountryInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CountryInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CountryInfo[key];
    }
  });
});